/* tslint:disable */
/* eslint-disable */
/**
 * 3DSurvey API
 * Frontend API for 3d Survey
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Project } from './Project';
import {
    ProjectFromJSON,
    ProjectFromJSONTyped,
    ProjectToJSON,
} from './Project';

/**
 * 
 * @export
 * @interface GetProject200Response
 */
export interface GetProject200Response {
    /**
     * 
     * @type {boolean}
     * @memberof GetProject200Response
     */
    success: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetProject200Response
     */
    error: string;
    /**
     * 
     * @type {Project}
     * @memberof GetProject200Response
     */
    data: Project;
}

/**
 * Check if a given object implements the GetProject200Response interface.
 */
export function instanceOfGetProject200Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "success" in value;
    isInstance = isInstance && "error" in value;
    isInstance = isInstance && "data" in value;

    return isInstance;
}

export function GetProject200ResponseFromJSON(json: any): GetProject200Response {
    return GetProject200ResponseFromJSONTyped(json, false);
}

export function GetProject200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetProject200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'success': json['success'],
        'error': json['error'],
        'data': ProjectFromJSON(json['data']),
    };
}

export function GetProject200ResponseToJSON(value?: GetProject200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'success': value.success,
        'error': value.error,
        'data': ProjectToJSON(value.data),
    };
}

